import axios from 'axios';

export const BASEURL = `${window.location.protocol}//${window.location.host}`;
export const PROXY_URL =
    process.env.REACT_APP_PROXY_URL === undefined ? 'http://localhost:3001' : process.env.REACT_APP_PROXY_URL;

const userPoolId = process.env.REACT_APP_USER_POOL_ID;
const config = {
    BASEURL,
    PROXY_URL,

    AUTH_ISSUER: 'https://cognito-idp.eu-west-1.amazonaws.com/' + userPoolId,
    AUTH_CLIENT_ID: process.env.REACT_APP_USER_POOL_CLIENT_ID
};

// load dynamic configuration (envs) from proxy
config.load = () =>
    axios
        .get(`${PROXY_URL}/config`)
        .then(res => Object.assign(config, res.data))
        .catch(err => console.error('Unable to load configuration', err));

export default config;
